export default __webpack_public_path__ + "static/media/lock_closed.ec4c7ff4.svg";